import { Model } from '@vuex-orm/core'

export class LessonGrade extends Model {
  static entity = 'lessonGrade'
  static primaryKey = ['lesson_id', 'grade_id']

  static fields () {
    return {
      lesson_id: this.attr(null),
      grade_id: this.attr(null)
    }
  }
}

export default LessonGrade
